<template>
  <div class="memberCotnainer">
    <div class="memberInfo" v-for="item in groupMembers" :key="item.Key">
      <img class="memberHead" :src="baseUrl + item.Member.HeadImage" />
      <div class="name focus" v-if="item.IsManager">{{ item.Member.RealName }}</div>
      <div class="name" v-else>{{ item.Member.RealName }}</div>
    </div>
    <span class="icon el-icon-plus" style="color:red;">{{ groupMembers.length }}</span>
  </div>
</template>
<script>
export default {
  props: {
    groupMembers: [],
  },
  data() {
    return {
    };
  },
  methods: {
  },
  mounted() { },
};
</script>
<style lang='scss' scoped>
.memberCotnainer {
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  height: auto;
  font-size: 12px;
  padding: 5px;
  .memberInfo {
    display: flex;
    flex-direction: column;
    align-items: center;
    .memberHead {
      border-radius: 50%;
      height: 40px;
    }
    .name{
    }
    .focus{
      font-weight: bold;
    }
  }
}
</style>